
// @ts-nocheck
import locale__codebuild_output_src2336706042_src_online_profile_bookforme_nuxt_lang_en_json from "../lang/en.json";
import locale__codebuild_output_src2336706042_src_online_profile_bookforme_nuxt_lang_ar_json from "../lang/ar.json";


export const localeCodes =  [
  "en",
  "ar"
]

export const localeLoaders = {
  "en": [{ key: "../lang/en.json", load: () => Promise.resolve(locale__codebuild_output_src2336706042_src_online_profile_bookforme_nuxt_lang_en_json), cache: true }],
  "ar": [{ key: "../lang/ar.json", load: () => Promise.resolve(locale__codebuild_output_src2336706042_src_online_profile_bookforme_nuxt_lang_ar_json), cache: true }]
}

export const vueI18nConfigs = [
  
]

export const nuxtI18nOptions = {
  "experimental": {
    "localeDetector": "",
    "switchLocalePathLinkSSR": false,
    "autoImportTranslationFunctions": false
  },
  "bundle": {
    "compositionOnly": true,
    "runtimeOnly": false,
    "fullInstall": true,
    "dropMessageCompiler": false
  },
  "compilation": {
    "jit": true,
    "strictMessage": true,
    "escapeHtml": false
  },
  "customBlocks": {
    "defaultSFCLang": "json",
    "globalSFCScope": false
  },
  "vueI18n": "",
  "locales": [
    {
      "name": "English",
      "language": "en-US",
      "code": "en",
      "dir": "ltr",
      "files": [
        "/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/lang/en.json"
      ]
    },
    {
      "name": "عربي",
      "language": "ar-KW",
      "code": "ar",
      "dir": "rtl",
      "files": [
        "/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/lang/ar.json"
      ]
    }
  ],
  "defaultLocale": "ar",
  "defaultDirection": "ltr",
  "routesNameSeparator": "___",
  "trailingSlash": false,
  "defaultLocaleRouteNameSuffix": "default",
  "strategy": "prefix",
  "lazy": false,
  "langDir": "lang/",
  "detectBrowserLanguage": false,
  "differentDomains": false,
  "baseUrl": "https://www.bookforme.com",
  "dynamicRouteParams": false,
  "customRoutes": "page",
  "pages": {},
  "skipSettingLocaleOnNavigate": false,
  "types": "composition",
  "debug": false,
  "parallelPlugin": false,
  "multiDomainLocales": false,
  "fallbackLocale": "en",
  "i18nModules": []
}

export const normalizedLocales = [
  {
    "name": "English",
    "language": "en-US",
    "code": "en",
    "dir": "ltr",
    "files": [
      {
        "path": "/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/lang/en.json"
      }
    ]
  },
  {
    "name": "عربي",
    "language": "ar-KW",
    "code": "ar",
    "dir": "rtl",
    "files": [
      {
        "path": "/codebuild/output/src2336706042/src/online-profile-bookforme-nuxt/lang/ar.json"
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false

export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18n"
export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
